<template>
  <b-container>
    <b-row>
      <b-col md="6" offset-md="3" :class="{'section' : (question.component === 'Section')}">
        <div class="text-muted qprogress">{{selectedIndex + 1}} of {{totalQuestions}}</div>
        <h5>{{question.title}}</h5>
        <p class="text-medium" v-if="question.subtitle">{{question.subtitle}}</p>
        <component
          :is="question.component"
          :key="question.id"
          :question="question"
          @answered="handleAnswer"
        ></component>
      </b-col>
    </b-row>
    <img height="1" width="1" style="display:none;" alt="" src="https://px.ads.linkedin.com/collect/?pid=2376460&conversionId=3003188&fmt=gif" />
  </b-container>
</template>
<script>
import $member from '@/services/member';
import questions from '@/questions.json';
import Section from '@/components/questions/Section.vue';
import MultipleChoiceQuestion from '@/components/questions/MultipleChoiceQuestion.vue';
import SingleChoiceQuestion from '@/components/questions/SingleChoiceQuestion.vue';

export default {
  components: {
    Section,
    MultipleChoiceQuestion,
    SingleChoiceQuestion,
  },
  props: {
    qid: {
      type: String,
      required: false,
      default: 'primaryChallenges',
    },
  },
  data() {
    return {
      selectedIndex: -1,
      totalQuestions: questions.length,
      question: null,
      member: {
        profile: {},
        score: 0,
      },
    };
  },
  methods: {
    next(jumpToKey) {
      if (jumpToKey) {
        this.$router.push({ name: 'Interview', params: { qid: jumpToKey } });
      } else if (this.selectedIndex < questions.length - 1) {
        const nextQuestion = questions[this.selectedIndex + 1];
        this.$router.push({ name: 'Interview', params: { qid: nextQuestion.id } });
      } else {
        $member.markComplete();
        this.$router.push({ name: 'ThankYou' });
      }
    },
    handleAnswer(answer) {
      if (this.question.component === 'Section') {
        this.next();
      } else {
        $member.saveAnswer(this.question, answer);
        this.next(answer.jumpTo);
      }
    },
  },
  created() {
    if (!$member.getMember()) {
      window.location.href = '/';
    }
    this.selectedIndex = questions.map((q) => q.id).indexOf(this.qid);
    this.question = questions[this.selectedIndex];
  },
};
</script>
<style scoped>
  .qprogress
  {
    font-size: 11px;
    margin-bottom:4px;
  }
  .section
  {
    border-top: solid 20px lavender;
    padding-top: 10px;
  }
</style>
